import {useMediaQuery} from '@mantine/hooks'

export const useIsMobile = () => {
    const query = '(max-width: 768px)';
    const mediaQueryResult = useMediaQuery(query);

    if (mediaQueryResult !== undefined) {
        return mediaQueryResult;
    }

    const result = window.matchMedia(query);
    return result.matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

let firstRunOfUseIsWideScreen = true;

export const useIsWideScreen = () => {
    const query = '(min-width: 1024px)';
    const mediaQueryResult = useMediaQuery(query);

    if (firstRunOfUseIsWideScreen) {
        const result = window.matchMedia(query);
        firstRunOfUseIsWideScreen = false;
        return result.matches;
    }

    if (mediaQueryResult !== undefined) {
        return mediaQueryResult;
    }

    const result = window.matchMedia(query);
    return result.matches;
};

export const isOpfsSupported = () => {
    return typeof FileSystemFileHandle !== 'undefined' && 'createWritable' in FileSystemFileHandle.prototype;
};

const isRN = typeof window !== 'undefined' && Boolean(window.ReactNativeWebView);
export const isReactNativeWeb = () => {
    return isRN;
};

export const getIsTauriWebview = () => {
    return typeof window !== 'undefined' && Boolean(window.__TAURI__);
};
